import { VaultDeposit } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {},
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Deposit to Vault');
      },
      class: 'w-[500px] h-[700px]',
    },
  },
};

export default VaultDeposit;
